export default "__VITE_ASSET__CAWyYEaM__"